var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ts-select-teacher',{model:{value:(_vm.teacher_id),callback:function ($$v) {_vm.teacher_id=$$v},expression:"teacher_id"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }